import { render } from "./UpdateCustomField.vue?vue&type=template&id=ae49bc78"
import script from "./UpdateCustomField.vue?vue&type=script&lang=js"
export * from "./UpdateCustomField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__